// extracted by mini-css-extract-plugin
module.exports = {"loading":"PreviousSelector_loading__W9Xru","previousSelector":"PreviousSelector_previousSelector__3LfHP"};